









import Vue from 'vue';

import User from '@/models/users/User';

export default Vue.extend({
    computed: {
        user(): User {
            return this.$auth.user!;
        },
    },
});
